import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'src/taskpane/utility/bem';
import * as APP_CONSTANTS from 'src/taskpane/shared/Constants';
import { handleImagePathForDifferentEnv } from 'src/taskpane/shared/UtilityFunctions';
import { THEME_ID } from 'src/taskpane/shared/styles';
import { CmicContext } from 'src/taskpane/context/CmicContext';
import './styles.scss';

const className = cn('action-image');
const el = (name, mod) => cn(className, name, mod);

const ActionImage = ({ actionType, fill, center }) => {
    const { currentOfficeTheme } = useContext(CmicContext);

    const constructPmImageSrc = `${handleImagePathForDifferentEnv()}${currentOfficeTheme === THEME_ID.WHITE ? 'Construct_PM-WHITE.png' : 'Construct_PM-COLOR.png'}`;
    const imagingImageSrc = `${handleImagePathForDifferentEnv()}${currentOfficeTheme === THEME_ID.WHITE ? 'CMiC_Imaging-WHITE.png' : 'CMiC_Imaging-COLOR.png'}`;

    const renderActionImage = () => {
        if (actionType === APP_CONSTANTS.ACTION_ROLE.ECM) {
            return (
                <img
                    className={el(`imaging-image ${fill ? 'fill' : ''} ${center ? 'center' : ''}`)}
                    src={imagingImageSrc}
                />);
        } else return (
            <img className={el(`construct-pm-image ${fill ? 'fill' : ''} ${center ? 'center' : ''}`)}
                src={constructPmImageSrc}
            />);
    };

    return renderActionImage();
};

ActionImage.propTypes = {
    actionType: PropTypes.string.isRequired,
    fill: PropTypes.bool,
};

export default ActionImage;
